import React from "react";

import { numberWithCommas, isEmpty } from "lib/utils";

import { baseline_update_gray_48 } from "styles/img";
import * as C from "../../constants";
import { useLocalStorage } from "../../lib/useLocalStorage";

const VatText = {
  color: "#999",
  fontSize: "11px",
  display: "inline",
};

const BuySearchResult = ({
  type,
  estimateTrade,
  buyPointSearch,
  minutes,
  seconds,
}) => {
  const [serviceCode] = useLocalStorage(C.STORAGE_KEY.SERVICE_CODE);
  const display = C.Message.display[serviceCode];

  return (
    !isEmpty(estimateTrade) && (
      <>
        <h3 className="stit MT50">{type === "peg" ? "e금" : "e은"} 매수확인</h3>
        <div className="buy_wrap2">
          <span className="timeF">
            <img src={baseline_update_gray_48} alt="더보기" />
            <span onClick={buyPointSearch}>
              결제가능시간{" "}
              <em>
                {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
              </em>
            </span>
          </span>
          <ul className="pay_list">
            <li>
              <span className="left">단가</span>
              <span className="right">
                <em>{numberWithCommas(estimateTrade.price)}</em>
                <span className="right3"> KRW</span>
              </span>
            </li>
            <li>
              <span className="left">수량</span>
              <span className="right">
                <em>{estimateTrade.amount}</em>
                <span className="right3"> g</span>
              </span>
            </li>
            <li>
              <span className="left">
                수수료 <p style={VatText}>(VAT 포함)</p>
              </span>
              <span className="right">
                <em>{numberWithCommas(estimateTrade.fee)}</em>
                <span className="right3"> {display.unit}</span>
              </span>
            </li>
            <li>
              <span className="left">매수 {display.amount}</span>
              <span className="right">
                <em>
                  {numberWithCommas(
                    estimateTrade.totalPrice - estimateTrade.fee
                  )}
                </em>
                <span className="right3"> {display.unit}</span>
              </span>
            </li>
          </ul>
        </div>

        <div className="charge_wrap2">
          <ul className="pay_list">
            <li>
              <span className="left">총 사용 {display.amount}</span>
              <span className="right">
                <em className="blue">
                  {numberWithCommas(estimateTrade.totalPrice)}
                </em>{" "}
                {display.unit}
              </span>
            </li>
          </ul>
        </div>
      </>
    )
  );
};

export default BuySearchResult;
